import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Team } from 'api/models';
import { TeamsStore } from './store';

export const slice = createSlice({
  name: '@@TEAMS',
  initialState: TeamsStore.empty(),

  reducers: (create) => ({
    load: create.reducer((state: TeamsStore) => TeamsStore.load()(state)),

    putAll: create.reducer(
      (state: TeamsStore, { payload: teams }: PayloadAction<Team[]>) =>
        TeamsStore.putAll(teams)(),
    ),

    add: create.reducer(
      (state: TeamsStore, { payload: team }: PayloadAction<Team>) =>
        TeamsStore.add(team)(state),
    ),

    remove: create.reducer(
      (state: TeamsStore, { payload: teamId }: PayloadAction<number>) =>
        TeamsStore.remove(teamId)(state),
    ),

    update: create.reducer(
      (state: TeamsStore, { payload: team }: PayloadAction<Team>) =>
        TeamsStore.update(team)(state),
    ),
  }),
});
